import { RecipesToBind } from '@/types/recipe'
import axios from 'axios'

export default async function bindRecipesToCompilation(recipes: {
  items: RecipesToBind[]
}) {
  await axios.put(`/api/v1/recipe-compilation/mass/`, recipes)
}
